import React, { useEffect, useState } from 'react';
import { CloseIcon } from './svg';
import { useSelector } from 'react-redux';
import { Progress } from 'antd';

const SetupGuide = ({ openPopup, handlePopupClick }) => {
  const { userData } = useSelector((state) => state.user);
  const [percentage, setPercentage] = useState(0);
  const [completedTask, setCompletedTask] = useState(0);

  const profileCompletion = userData?.business?.profileCompletion || [];

  const socialLink = profileCompletion.includes('social');
  const website = profileCompletion.includes('website');
  const services = profileCompletion.includes('service');
  const workingHours = profileCompletion.includes('working hours');
  const stripeConnect = userData?.stripe_connect_charges_enabled === true;

  useEffect(() => {
    let completionCount = 0;
    if (socialLink) completionCount++;
    if (website) completionCount++;
    if (services) completionCount++;
    if (workingHours) completionCount++;
    if (stripeConnect) completionCount++;
    setCompletedTask(completionCount);
    setPercentage((completionCount / 5) * 100);
  }, [socialLink, website, services, workingHours, stripeConnect]);

  return (
    <>
      <div className={`modal right-modal ${!openPopup ? 'd-none' : ''}`}>
        <div className={`right-modal-content`}>
          <div className={`right-modal-header`}>
            <div className={`container-fluid`}>
              <div className={`row align-items-center`}>
                <div className={`col px-0`}>
                  <h3
                    className={`f-22 fw-normal poly color-primary m-0`}
                  >
                    Setup Guide
                  </h3>
                </div>
                <div className={`col-auto px-0`}>
                  <div
                    className={`cp`}
                    onClick={handlePopupClick}
                  >
                    <CloseIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`right-modal-body`}>
            <div className={`container-fluid`}>
              <div className={`row`}>
                <div className={`col-auto right-modal-chart`}>
                  <div className={`row align-items-center`}>
                    <div
                      className={`col-md col-9 px-10px lh-normal`}
                    >
                      <div className={`container-fluid`}>
                        <div className={`row`}>
                          <div
                            className={`col-12 px-0`}
                          >
                            <h3
                              className={`m-0 f-20px fw-normal poly color-primary text-capitalize`}
                            >
                              Hi,{userData?.name}
                              👋🏽
                            </h3>
                          </div>
                          <div
                            className={`col-12 px-0`}
                          >
                            <h6
                              className={`my-6 f-15 fw-normal poppins color-primary`}
                            >
                              continue setting up
                              your new account
                            </h6>
                          </div>
                          <div
                            className={`col-12 px-0`}
                          >
                            <span
                              className={`f-14 fw-normal poppins c-aa6f2b`}
                            >
                              {completedTask} of 5 task
                              completed
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-auto col-3`}>
                      <Progress
                        type="circle"
                        width={48}
                        percent={percentage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={`container-fluid`}>
              <div className={`row`}>
                <div className={`col check-box-card`}>
                  <div className={`container-fluid`}>
                    <div className={`row`}>
                      <div className={`col-12 px-0`}>
                        <input
                          id={`radio-1`}
                          className={`radio-input app-none position-absolute`}
                          type={'checkbox'}
                          name={`radio-1`}
                          checked={socialLink}
                          disabled
                        />
                        <label
                          htmlFor="radio-1"
                          className={`d-flex radio-label cp`}
                        >
                          <div className={`col px-0`}>
                            <span
                              className={`f-16 fw-normal poppins c-101828`}
                            >
                              Add your social
                              links
                            </span>
                          </div>
                          <div
                            className={`col-auto px-0`}
                          >
                            <div
                              className={`radio-btn`}
                            />
                          </div>
                        </label>
                      </div>
                      <div className={`col-12 px-0`}>
                        <div
                          className={`hl-radio my-14`}
                        />
                      </div>
                      <div className={`col-12 px-0`}>
                        <input
                          id={`radio-2`}
                          className={`radio-input app-none position-absolute`}
                          disabled
                          checked={website}
                          type={'checkbox'}
                          name={`radio-2`}
                        />
                        <label
                          htmlFor="radio-2"
                          className={`d-flex radio-label cp`}
                        >
                          <div className={`col px-0`}>
                            <span
                              className={`f-16 fw-normal poppins c-101828`}
                            >
                              Add your business
                              website
                            </span>
                          </div>
                          <div
                            className={`col-auto px-0`}
                          >
                            <div
                              className={`radio-btn`}
                            />
                          </div>
                        </label>
                      </div>
                      <div className={`col-12 px-0`}>
                        <div
                          className={`hl-radio my-14`}
                        />
                      </div>
                      <div className={`col-12 px-0`}>
                        <input
                          id={`radio-3`}
                          className={`radio-input app-none position-absolute`}
                          disabled
                          checked={services}
                          type={'checkbox'}
                          name={`radio-3`}
                        />
                        <label
                          htmlFor="radio-3"
                          className={`d-flex radio-label cp`}
                        >
                          <div className={`col px-0`}>
                            <span
                              className={`f-16 fw-normal poppins c-101828`}
                            >
                              Set up your service
                              list
                            </span>
                          </div>
                          <div
                            className={`col-auto px-0`}
                          >
                            <div
                              className={`radio-btn`}
                            />
                          </div>
                        </label>
                      </div>
                      <div className={`col-12 px-0`}>
                        <div
                          className={`hl-radio my-14`}
                        />
                      </div>
                      <div className={`col-12 px-0`}>
                        <input
                          id={`radio-4`}
                          className={`radio-input app-none position-absolute`}
                          type={'checkbox'}
                          name={`radio-4`}
                          disabled
                          checked={workingHours}
                        />
                        <label
                          htmlFor="radio-4"
                          className={`d-flex radio-label cp`}
                        >
                          <div className={`col px-0`}>
                            <span
                              className={`f-16 fw-normal poppins c-101828`}
                            >
                              Set your working
                              hours
                            </span>
                          </div>
                          <div
                            className={`col-auto px-0`}
                          >
                            <div
                              className={`radio-btn`}
                            />
                          </div>
                        </label>
                      </div>
                      <div className={`col-12 px-0`}>
                        <div
                          className={`hl-radio my-14`}
                        />
                      </div>
                      <div className={`col-12 px-0`}>
                        <input
                          id={`radio-5`}
                          className={`radio-input app-none position-absolute`}
                          type={'checkbox'}
                          name={`radio-5`}
                          disabled
                          checked={stripeConnect}
                        />
                        <label
                          htmlFor="radio-5"
                          className={`d-flex radio-label cp`}
                        >
                          <div className={`col px-0`}>
                            <span
                              className={`f-16 fw-normal poppins c-101828`}
                            >
                              Connect Account
                            </span>
                          </div>
                          <div
                            className={`col-auto px-0`}
                          >
                            <div
                              className={`radio-btn`}
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className={`row`}>
                <div className={`col-12 px-0 pb-20`}>
                  <h3 className={`m-0 f-22 fw-normal color-primary poly`}>
                    Things to try
                  </h3>
                </div>

                <div className={`col-md-6 col-12 ps-0 pr-md-8 px-0px pb-8`}>
                  <div className={`card-default p-16px h-168`}>
                    <div className={`container-fluid`}>
                      <div className={`row`}>
                        <div className={`col ps-0 pb-16`}>
                          <h3
                            className={`m-0 f-14px fw-normal poppins c-101828 h-84px lh-normal`}
                          >
                            Create your first appointment in the calendar
                          </h3>
                        </div>
                        <div className={`col-auto px-0`}>
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M29.25 4.5H25.875V3.375C25.875 3.07663 25.7565 2.79048 25.5455 2.5795C25.3345 2.36853 25.0484 2.25 24.75 2.25C24.4516 2.25 24.1655 2.36853 23.9545 2.5795C23.7435 2.79048 23.625 3.07663 23.625 3.375V4.5H12.375V3.375C12.375 3.07663 12.2565 2.79048 12.0455 2.5795C11.8345 2.36853 11.5484 2.25 11.25 2.25C10.9516 2.25 10.6655 2.36853 10.4545 2.5795C10.2435 2.79048 10.125 3.07663 10.125 3.375V4.5H6.75C6.15326 4.5 5.58097 4.73705 5.15901 5.15901C4.73705 5.58097 4.5 6.15326 4.5 6.75V29.25C4.5 29.8467 4.73705 30.419 5.15901 30.841C5.58097 31.2629 6.15326 31.5 6.75 31.5H29.25C29.8467 31.5 30.419 31.2629 30.841 30.841C31.2629 30.419 31.5 29.8467 31.5 29.25V6.75C31.5 6.15326 31.2629 5.58097 30.841 5.15901C30.419 4.73705 29.8467 4.5 29.25 4.5ZM10.125 6.75V7.875C10.125 8.17337 10.2435 8.45952 10.4545 8.6705C10.6655 8.88147 10.9516 9 11.25 9C11.5484 9 11.8345 8.88147 12.0455 8.6705C12.2565 8.45952 12.375 8.17337 12.375 7.875V6.75H23.625V7.875C23.625 8.17337 23.7435 8.45952 23.9545 8.6705C24.1655 8.88147 24.4516 9 24.75 9C25.0484 9 25.3345 8.88147 25.5455 8.6705C25.7565 8.45952 25.875 8.17337 25.875 7.875V6.75H29.25V11.25H6.75V6.75H10.125ZM29.25 29.25H6.75V13.5H29.25V29.25ZM22.5 21.375C22.5 21.6734 22.3815 21.9595 22.1705 22.1705C21.9595 22.3815 21.6734 22.5 21.375 22.5H19.125V24.75C19.125 25.0484 19.0065 25.3345 18.7955 25.5455C18.5845 25.7565 18.2984 25.875 18 25.875C17.7016 25.875 17.4155 25.7565 17.2045 25.5455C16.9935 25.3345 16.875 25.0484 16.875 24.75V22.5H14.625C14.3266 22.5 14.0405 22.3815 13.8295 22.1705C13.6185 21.9595 13.5 21.6734 13.5 21.375C13.5 21.0766 13.6185 20.7905 13.8295 20.5795C14.0405 20.3685 14.3266 20.25 14.625 20.25H16.875V18C16.875 17.7016 16.9935 17.4155 17.2045 17.2045C17.4155 16.9935 17.7016 16.875 18 16.875C18.2984 16.875 18.5845 16.9935 18.7955 17.2045C19.0065 17.4155 19.125 17.7016 19.125 18V20.25H21.375C21.6734 20.25 21.9595 20.3685 22.1705 20.5795C22.3815 20.7905 22.5 21.0766 22.5 21.375Z"
                              fill="black"
                            />
                          </svg>
                        </div>
                        <div className={`col-12 px-0`}>
                          <button className={`btn btn-try-now`}>
                            Try Now
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.55977 2.31522L9.93477 6.69022C9.97545 6.73086 10.0077 6.77911 10.0297 6.83222C10.0518 6.88533 10.0631 6.94226 10.0631 6.99976C10.0631 7.05725 10.0518 7.11418 10.0297 7.16729C10.0077 7.2204 9.97545 7.26866 9.93477 7.30929L5.55977 11.6843C5.47768 11.7664 5.36634 11.8125 5.25024 11.8125C5.13415 11.8125 5.0228 11.7664 4.94071 11.6843C4.85862 11.6022 4.8125 11.4909 4.8125 11.3748C4.8125 11.2587 4.85862 11.1473 4.94071 11.0652L9.00673 6.99976L4.94071 2.93429C4.90006 2.89364 4.86782 2.84538 4.84582 2.79227C4.82382 2.73916 4.8125 2.68224 4.8125 2.62476C4.8125 2.56727 4.82382 2.51035 4.84582 2.45724C4.86782 2.40413 4.90006 2.35587 4.94071 2.31522C4.98136 2.27458 5.02962 2.24233 5.08273 2.22033C5.13584 2.19834 5.19276 2.18701 5.25024 2.18701C5.30773 2.18701 5.36465 2.19834 5.41776 2.22033C5.47087 2.24233 5.51913 2.27458 5.55977 2.31522Z"
                                fill="#2b5c35"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`col-md-6 col-12 pl-md-8 pe-0 px-0px pb-8`}>
                  <div className={`card-default p-16px h-168`}>
                    <div className={`container-fluid`}>
                      <div className={`row`}>
                        <div className={`col ps-0 pb-16`}>
                          <h3
                            className={`m-0 f-14px fw-normal poppins c-101828 h-84px lh-normal`}
                          >
                            check out your appointments to unlock reports that
                            simplify your admin tasks
                          </h3>
                        </div>
                        <div className={`col-auto px-0`}>
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M29.25 4.5H25.875V3.375C25.875 3.07663 25.7565 2.79048 25.5455 2.5795C25.3345 2.36853 25.0484 2.25 24.75 2.25C24.4516 2.25 24.1655 2.36853 23.9545 2.5795C23.7435 2.79048 23.625 3.07663 23.625 3.375V4.5H12.375V3.375C12.375 3.07663 12.2565 2.79048 12.0455 2.5795C11.8345 2.36853 11.5484 2.25 11.25 2.25C10.9516 2.25 10.6655 2.36853 10.4545 2.5795C10.2435 2.79048 10.125 3.07663 10.125 3.375V4.5H6.75C6.15326 4.5 5.58097 4.73705 5.15901 5.15901C4.73705 5.58097 4.5 6.15326 4.5 6.75V29.25C4.5 29.8467 4.73705 30.419 5.15901 30.841C5.58097 31.2629 6.15326 31.5 6.75 31.5H29.25C29.8467 31.5 30.419 31.2629 30.841 30.841C31.2629 30.419 31.5 29.8467 31.5 29.25V6.75C31.5 6.15326 31.2629 5.58097 30.841 5.15901C30.419 4.73705 29.8467 4.5 29.25 4.5ZM10.125 6.75V7.875C10.125 8.17337 10.2435 8.45952 10.4545 8.6705C10.6655 8.88147 10.9516 9 11.25 9C11.5484 9 11.8345 8.88147 12.0455 8.6705C12.2565 8.45952 12.375 8.17337 12.375 7.875V6.75H23.625V7.875C23.625 8.17337 23.7435 8.45952 23.9545 8.6705C24.1655 8.88147 24.4516 9 24.75 9C25.0484 9 25.3345 8.88147 25.5455 8.6705C25.7565 8.45952 25.875 8.17337 25.875 7.875V6.75H29.25V11.25H6.75V6.75H10.125ZM29.25 29.25H6.75V13.5H29.25V29.25ZM15.75 16.875V25.875C15.75 26.1734 15.6315 26.4595 15.4205 26.6705C15.2095 26.8815 14.9234 27 14.625 27C14.3266 27 14.0405 26.8815 13.8295 26.6705C13.6185 26.4595 13.5 26.1734 13.5 25.875V18.6947L12.8784 19.0069C12.6114 19.1404 12.3023 19.1624 12.019 19.068C11.7358 18.9735 11.5016 18.7705 11.3681 18.5034C11.2346 18.2364 11.2126 17.9273 11.307 17.644C11.4015 17.3608 11.6045 17.1266 11.8716 16.9931L14.1216 15.8681C14.2931 15.7823 14.4838 15.7417 14.6755 15.7503C14.8672 15.7589 15.0534 15.8164 15.2166 15.9173C15.3798 16.0182 15.5145 16.1592 15.6079 16.3268C15.7012 16.4944 15.7501 16.6831 15.75 16.875ZM24.0694 21.157L21.375 24.75H23.625C23.9234 24.75 24.2095 24.8685 24.4205 25.0795C24.6315 25.2905 24.75 25.5766 24.75 25.875C24.75 26.1734 24.6315 26.4595 24.4205 26.6705C24.2095 26.8815 23.9234 27 23.625 27H19.125C18.9161 27 18.7113 26.9418 18.5336 26.832C18.3558 26.7221 18.2122 26.565 18.1188 26.3781C18.0253 26.1912 17.9858 25.982 18.0045 25.774C18.0233 25.5659 18.0996 25.3671 18.225 25.2L22.2722 19.8042C22.3642 19.6817 22.4303 19.5416 22.4663 19.3926C22.5022 19.2436 22.5074 19.0888 22.4814 18.9378C22.4554 18.7867 22.3988 18.6426 22.3151 18.5142C22.2314 18.3858 22.1223 18.2758 21.9946 18.1911C21.8669 18.1064 21.7232 18.0486 21.5723 18.0214C21.4215 17.9942 21.2667 17.9981 21.1174 18.0329C20.9681 18.0677 20.8275 18.1326 20.7043 18.2237C20.581 18.3147 20.4776 18.43 20.4005 18.5625C20.3288 18.6945 20.2314 18.8108 20.114 18.9046C19.9966 18.9984 19.8617 19.0677 19.7171 19.1085C19.5725 19.1492 19.4212 19.1606 19.2721 19.1419C19.123 19.1233 18.9792 19.075 18.8491 18.9998C18.719 18.9247 18.6053 18.8242 18.5147 18.7044C18.424 18.5846 18.3583 18.4479 18.3214 18.3023C18.2844 18.1567 18.277 18.0051 18.2996 17.8566C18.3222 17.7081 18.3743 17.5656 18.4528 17.4375C18.8244 16.7944 19.3978 16.2919 20.0841 16.0078C20.7703 15.7237 21.5312 15.6739 22.2486 15.8661C22.966 16.0584 23.6 16.482 24.0523 17.0711C24.5045 17.6603 24.7498 18.3823 24.75 19.125C24.7524 19.8587 24.5132 20.5728 24.0694 21.157Z"
                              fill="black"
                            />
                          </svg>
                        </div>
                        <div className={`col-12 px-0`}>
                          <button className={`btn btn-try-now`}>
                            Try Now
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.55977 2.31522L9.93477 6.69022C9.97545 6.73086 10.0077 6.77911 10.0297 6.83222C10.0518 6.88533 10.0631 6.94226 10.0631 6.99976C10.0631 7.05725 10.0518 7.11418 10.0297 7.16729C10.0077 7.2204 9.97545 7.26866 9.93477 7.30929L5.55977 11.6843C5.47768 11.7664 5.36634 11.8125 5.25024 11.8125C5.13415 11.8125 5.0228 11.7664 4.94071 11.6843C4.85862 11.6022 4.8125 11.4909 4.8125 11.3748C4.8125 11.2587 4.85862 11.1473 4.94071 11.0652L9.00673 6.99976L4.94071 2.93429C4.90006 2.89364 4.86782 2.84538 4.84582 2.79227C4.82382 2.73916 4.8125 2.68224 4.8125 2.62476C4.8125 2.56727 4.82382 2.51035 4.84582 2.45724C4.86782 2.40413 4.90006 2.35587 4.94071 2.31522C4.98136 2.27458 5.02962 2.24233 5.08273 2.22033C5.13584 2.19834 5.19276 2.18701 5.25024 2.18701C5.30773 2.18701 5.36465 2.19834 5.41776 2.22033C5.47087 2.24233 5.51913 2.27458 5.55977 2.31522Z"
                                fill="#2b5c35"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`col-md-6 col-12 ps-0 pr-md-8 px-0px pt-8`}>
                  <div className={`card-default p-16px h-168`}>
                    <div className={`container-fluid`}>
                      <div className={`row`}>
                        <div className={`col ps-0 pb-16`}>
                          <h3
                            className={`m-0 f-14px fw-normal poppins c-101828 h-84px lh-normal`}
                          >
                            import your clients and instantly book your regular
                            with the click of a button
                          </h3>
                        </div>
                        <div className={`col-auto px-0`}>
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_712_189)">
                              <path
                                d="M36.0001 19.1267C36.0001 19.4251 35.8816 19.7112 35.6706 19.9222C35.4596 20.1332 35.1735 20.2517 34.8751 20.2517H32.6251V22.5017C32.6251 22.8001 32.5066 23.0862 32.2956 23.2972C32.0846 23.5082 31.7985 23.6267 31.5001 23.6267C31.2018 23.6267 30.9156 23.5082 30.7046 23.2972C30.4936 23.0862 30.3751 22.8001 30.3751 22.5017V20.2517H28.1251C27.8268 20.2517 27.5406 20.1332 27.3296 19.9222C27.1186 19.7112 27.0001 19.4251 27.0001 19.1267C27.0001 18.8283 27.1186 18.5422 27.3296 18.3312C27.5406 18.1202 27.8268 18.0017 28.1251 18.0017H30.3751V15.7517C30.3751 15.4533 30.4936 15.1672 30.7046 14.9562C30.9156 14.7452 31.2018 14.6267 31.5001 14.6267C31.7985 14.6267 32.0846 14.7452 32.2956 14.9562C32.5066 15.1672 32.6251 15.4533 32.6251 15.7517V18.0017H34.8751C35.1735 18.0017 35.4596 18.1202 35.6706 18.3312C35.8816 18.5422 36.0001 18.8283 36.0001 19.1267ZM27.8622 27.4025C28.0542 27.6311 28.1476 27.9267 28.1218 28.2242C28.0959 28.5216 27.953 28.7967 27.7243 28.9888C27.4957 29.1808 27.2002 29.2742 26.9027 29.2484C26.6052 29.2225 26.3302 29.0796 26.1381 28.8509C23.3087 25.4816 19.419 23.6267 15.1876 23.6267C10.9562 23.6267 7.06653 25.4816 4.23715 28.8509C4.04508 29.0794 3.77012 29.2222 3.47278 29.2479C3.17543 29.2736 2.88005 29.1801 2.65161 28.988C2.42317 28.796 2.28039 28.521 2.25468 28.2237C2.22896 27.9263 2.32242 27.6309 2.5145 27.4025C4.61544 24.9022 7.22825 23.1261 10.1322 22.1755C8.36858 21.0771 7.01073 19.4341 6.26403 17.4953C5.51733 15.5564 5.42241 13.4271 5.99363 11.4295C6.56485 9.43194 7.77113 7.67473 9.42997 6.42375C11.0888 5.17277 13.11 4.49609 15.1876 4.49609C17.2653 4.49609 19.2864 5.17277 20.9453 6.42375C22.6041 7.67473 23.8104 9.43194 24.3816 11.4295C24.9528 13.4271 24.8579 15.5564 24.1112 17.4953C23.3645 19.4341 22.0067 21.0771 20.2431 22.1755C23.147 23.1261 25.7598 24.9022 27.8622 27.4025ZM15.1876 21.3767C16.6339 21.3767 18.0477 20.9478 19.2502 20.1443C20.4528 19.3408 21.39 18.1988 21.9435 16.8626C22.497 15.5264 22.6418 14.0561 22.3596 12.6376C22.0775 11.2191 21.381 9.91617 20.3583 8.8935C19.3357 7.87083 18.0327 7.17438 16.6142 6.89223C15.1957 6.61007 13.7254 6.75488 12.3893 7.30835C11.0531 7.86181 9.91101 8.79908 9.1075 10.0016C8.30399 11.2041 7.87512 12.6179 7.87512 14.0642C7.87736 16.0029 8.6485 17.8616 10.0194 19.2325C11.3902 20.6033 13.2489 21.3745 15.1876 21.3767Z"
                                fill="black"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_712_189">
                                <rect width="36" height="36" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div className={`col-12 px-0`}>
                          <button className={`btn btn-try-now`}>
                            Try Now
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.55977 2.31522L9.93477 6.69022C9.97545 6.73086 10.0077 6.77911 10.0297 6.83222C10.0518 6.88533 10.0631 6.94226 10.0631 6.99976C10.0631 7.05725 10.0518 7.11418 10.0297 7.16729C10.0077 7.2204 9.97545 7.26866 9.93477 7.30929L5.55977 11.6843C5.47768 11.7664 5.36634 11.8125 5.25024 11.8125C5.13415 11.8125 5.0228 11.7664 4.94071 11.6843C4.85862 11.6022 4.8125 11.4909 4.8125 11.3748C4.8125 11.2587 4.85862 11.1473 4.94071 11.0652L9.00673 6.99976L4.94071 2.93429C4.90006 2.89364 4.86782 2.84538 4.84582 2.79227C4.82382 2.73916 4.8125 2.68224 4.8125 2.62476C4.8125 2.56727 4.82382 2.51035 4.84582 2.45724C4.86782 2.40413 4.90006 2.35587 4.94071 2.31522C4.98136 2.27458 5.02962 2.24233 5.08273 2.22033C5.13584 2.19834 5.19276 2.18701 5.25024 2.18701C5.30773 2.18701 5.36465 2.19834 5.41776 2.22033C5.47087 2.24233 5.51913 2.27458 5.55977 2.31522Z"
                                fill="#2b5c35"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`col-md-6 col-12 pl-md-8 pe-0 px-0px pt-8`}>
                  <div className={`card-default p-16px h-168`}>
                    <div className={`container-fluid`}>
                      <div className={`row`}>
                        <div className={`col ps-0 pb-16`}>
                          <h3
                            className={`m-0 f-14px fw-normal poppins c-101828 h-84px lh-normal`}
                          >
                            Keep in touch with automatic appointment
                            notifications, ‘thank you’ message and more
                          </h3>
                        </div>
                        <div className={`col-auto px-0`}>
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.75 23.2503C15.75 24.0753 16.425 24.7503 17.25 24.7503C18.075 24.7503 18.75 24.0753 18.75 23.2503M15.75 14.2503C15.751 14.0497 15.7922 13.8513 15.8713 13.6669C15.9503 13.4824 16.0656 13.3158 16.2102 13.1767C16.3548 13.0376 16.5259 12.9289 16.7132 12.8571C16.9006 12.7853 17.1005 12.7519 17.301 12.7587C17.5015 12.7655 17.6987 12.8125 17.8807 12.8969C18.0628 12.9812 18.226 13.1013 18.3609 13.2499C18.4957 13.3985 18.5993 13.5726 18.6657 13.762C18.732 13.9513 18.7596 14.1521 18.747 14.3523C19.4817 14.6396 20.1132 15.141 20.5596 15.7915C21.006 16.4419 21.2467 17.2115 21.2505 18.0003V18.4983C21.2505 20.2803 21.9705 21.9903 23.25 23.2503H11.25C11.882 22.6306 12.3843 21.8913 12.7276 21.0754C13.0709 20.2595 13.2483 19.3835 13.2495 18.4983V18.0003C13.2495 16.3473 14.286 14.9358 15.7545 14.3523C15.7519 14.3184 15.7504 14.2844 15.75 14.2503Z"
                              stroke="black"
                              stroke-width="1.9"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M5.25 9.75H29.25M9.75 2.25V6.75M17.25 2.25V6.75M24.75 2.25V6.75M27.75 5.25H6.75C6.35218 5.25 5.97064 5.40804 5.68934 5.68934C5.40804 5.97064 5.25 6.35218 5.25 6.75V27.75C5.25 28.1478 5.40804 28.5294 5.68934 28.8107C5.97064 29.092 6.35218 29.25 6.75 29.25H27.75C28.1478 29.25 28.5294 29.092 28.8107 28.8107C29.092 28.5294 29.25 28.1478 29.25 27.75V6.75C29.25 6.35218 29.092 5.97064 28.8107 5.68934C28.5294 5.40804 28.1478 5.25 27.75 5.25Z"
                              stroke="black"
                              stroke-width="1.9"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div className={`col-12 px-0`}>
                          <button className={`btn btn-try-now`}>
                            Try Now
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.55977 2.31522L9.93477 6.69022C9.97545 6.73086 10.0077 6.77911 10.0297 6.83222C10.0518 6.88533 10.0631 6.94226 10.0631 6.99976C10.0631 7.05725 10.0518 7.11418 10.0297 7.16729C10.0077 7.2204 9.97545 7.26866 9.93477 7.30929L5.55977 11.6843C5.47768 11.7664 5.36634 11.8125 5.25024 11.8125C5.13415 11.8125 5.0228 11.7664 4.94071 11.6843C4.85862 11.6022 4.8125 11.4909 4.8125 11.3748C4.8125 11.2587 4.85862 11.1473 4.94071 11.0652L9.00673 6.99976L4.94071 2.93429C4.90006 2.89364 4.86782 2.84538 4.84582 2.79227C4.82382 2.73916 4.8125 2.68224 4.8125 2.62476C4.8125 2.56727 4.82382 2.51035 4.84582 2.45724C4.86782 2.40413 4.90006 2.35587 4.94071 2.31522C4.98136 2.27458 5.02962 2.24233 5.08273 2.22033C5.13584 2.19834 5.19276 2.18701 5.25024 2.18701C5.30773 2.18701 5.36465 2.19834 5.41776 2.22033C5.47087 2.24233 5.51913 2.27458 5.55977 2.31522Z"
                                fill="#2b5c35"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <a
                href="mailto:help@nextsalon.com"
                target="_blank"
                className="text-decoration-none"
              >
                <div className={`row`}>
                  <div className={`col-12 card-need-help`}>
                    <div
                      className={`d-flex align-items-center`}
                    >
                      <div
                        className={`col-auto px-0 lh-0`}
                      >
                        <svg
                          width="52"
                          height="52"
                          viewBox="0 0 52 52"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="52"
                            height="52"
                            rx="10"
                            fill="white"
                          />
                          <path
                            d="M38.9739 33.4177C39.6792 31.9842 40.0307 30.4026 39.999 28.8053C39.9674 27.208 39.5535 25.6415 38.792 24.237C38.0306 22.8326 36.9437 21.631 35.6224 20.7329C34.3011 19.8348 32.7838 19.2664 31.1977 19.0752C30.6695 17.852 29.9022 16.7466 28.9409 15.824C27.9795 14.9014 26.8435 14.1802 25.5995 13.7029C24.3555 13.2255 23.0287 13.0016 21.697 13.0442C20.3652 13.0868 19.0554 13.3951 17.8445 13.9511C16.6336 14.507 15.546 15.2993 14.6456 16.2815C13.7452 17.2637 13.0502 18.4159 12.6013 19.6704C12.1525 20.925 11.9589 22.2566 12.0319 23.587C12.1049 24.9174 12.443 26.2198 13.0264 27.4177L12.0689 30.7702C11.9945 31.0306 11.9814 31.3047 12.0309 31.5709C12.0803 31.8372 12.1909 32.0883 12.3538 32.3046C12.5168 32.5209 12.7277 32.6964 12.97 32.8173C13.2123 32.9382 13.4794 33.0013 13.7502 33.0015C13.9126 33.0019 14.0742 32.9792 14.2302 32.934L17.5827 31.9765C18.594 32.4764 19.6835 32.799 20.8039 32.9302C21.3373 34.1795 22.1197 35.3071 23.1032 36.244C24.0867 37.181 25.2509 37.9077 26.5246 38.3799C27.7982 38.8522 29.1548 39.0599 30.5114 38.9905C31.868 38.9212 33.1963 38.5761 34.4152 37.9765L37.7677 38.934C38.0676 39.0194 38.3849 39.0232 38.6868 38.9448C38.9886 38.8665 39.2641 38.7089 39.4846 38.4884C39.7051 38.2679 39.8627 37.9924 39.941 37.6906C40.0194 37.3887 40.0156 37.0714 39.9302 36.7715L38.9739 33.4177ZM18.1702 30.0277C17.9409 29.9025 17.6717 29.872 17.4202 29.9427L14.1189 30.8865L15.0627 27.5852C15.1334 27.3337 15.1029 27.0645 14.9777 26.8352C13.946 24.981 13.6931 22.7929 14.2747 20.7523C14.8563 18.7117 16.2247 16.9857 18.0789 15.954C19.9331 14.9223 22.1212 14.6694 24.1619 15.251C26.2025 15.8326 27.9285 17.201 28.9602 19.0552C26.5027 19.3156 24.2282 20.4753 22.5742 22.3114C20.9202 24.1475 20.0034 26.5302 20.0002 29.0015C20.0006 29.601 20.0554 30.1993 20.1639 30.789C19.468 30.6264 18.7974 30.3703 18.1702 30.0277ZM36.9414 33.5852L37.8852 36.8865L34.5839 35.9427C34.3324 35.872 34.0632 35.9025 33.8339 36.0277C32.1459 36.9472 30.183 37.2276 28.305 36.8175C26.4269 36.4075 24.7596 35.3344 23.6084 33.7949C22.4573 32.2555 21.8994 30.3528 22.037 28.4355C22.1747 26.5181 22.9986 24.7146 24.3578 23.3554C25.7171 21.9961 27.5206 21.1722 29.4379 21.0346C31.3552 20.8969 33.2579 21.4548 34.7974 22.606C36.3368 23.7571 37.4099 25.4245 37.82 27.3025C38.2301 29.1805 37.9497 31.1434 37.0302 32.8315C36.9027 33.0613 36.8708 33.3321 36.9414 33.5852ZM28.0002 27.5015C28.0002 27.7982 27.9122 28.0882 27.7474 28.3348C27.5826 28.5815 27.3483 28.7738 27.0742 28.8873C26.8001 29.0008 26.4985 29.0305 26.2076 28.9727C25.9166 28.9148 25.6493 28.7719 25.4395 28.5621C25.2297 28.3524 25.0869 28.0851 25.029 27.7941C24.9711 27.5031 25.0008 27.2015 25.1144 26.9275C25.2279 26.6534 25.4202 26.4191 25.6668 26.2543C25.9135 26.0895 26.2035 26.0015 26.5002 26.0015C26.898 26.0015 27.2795 26.1595 27.5608 26.4408C27.8422 26.7221 28.0002 27.1037 28.0002 27.5015ZM35.0002 27.5015C35.0002 27.7982 34.9122 28.0882 34.7474 28.3348C34.5826 28.5815 34.3483 28.7738 34.0742 28.8873C33.8001 29.0008 33.4985 29.0305 33.2076 28.9727C32.9166 28.9148 32.6493 28.7719 32.4395 28.5621C32.2297 28.3524 32.0869 28.0851 32.029 27.7941C31.9711 27.5031 32.0008 27.2015 32.1144 26.9275C32.2279 26.6534 32.4202 26.4191 32.6668 26.2543C32.9135 26.0895 33.2035 26.0015 33.5002 26.0015C33.898 26.0015 34.2795 26.1595 34.5608 26.4408C34.8422 26.7221 35.0002 27.1037 35.0002 27.5015Z"
                            fill="#E11919"
                          />
                        </svg>
                      </div>
                      <div className={`col pl-16`}>
                        <h3
                          className={`mb-4px c-e11919 f-16 fw-normal poly`}
                        >
                          Need more help?
                        </h3>
                        <h6
                          className={`m-0 text-gray f-14 fw-normal poppins`}
                        >
                          Reach out to our team or
                          visit our Help Center
                        </h6>
                      </div>
                      <div
                        className={`col-auto px-0 lh-0 justify-se`}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.53055 3.96896L17.0306 11.469C17.1003 11.5386 17.1556 11.6213 17.1933 11.7124C17.2311 11.8034 17.2505 11.901 17.2505 11.9996C17.2505 12.0981 17.2311 12.1957 17.1933 12.2868C17.1556 12.3778 17.1003 12.4606 17.0306 12.5302L9.53055 20.0302C9.38982 20.1709 9.19895 20.25 8.99993 20.25C8.80091 20.25 8.61003 20.1709 8.4693 20.0302C8.32857 19.8895 8.24951 19.6986 8.24951 19.4996C8.24951 19.3006 8.32857 19.1097 8.4693 18.969L15.4396 11.9996L8.4693 5.03021C8.39962 4.96053 8.34434 4.8778 8.30663 4.78676C8.26892 4.69571 8.24951 4.59813 8.24951 4.49958C8.24951 4.40104 8.26892 4.30346 8.30663 4.21241C8.34434 4.12137 8.39962 4.03864 8.4693 3.96896C8.53899 3.89927 8.62171 3.844 8.71276 3.80629C8.8038 3.76858 8.90138 3.74917 8.99993 3.74917C9.09847 3.74917 9.19606 3.76858 9.2871 3.80629C9.37815 3.844 9.46087 3.89927 9.53055 3.96896Z"
                            fill="#EB5757"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SetupGuide;
